import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalDialogComponent } from '@app/components/_index';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  standalone: false,
})
export class ConfirmDialogComponent {
  @Output() confirmClicked: EventEmitter<void> = new EventEmitter<void>();

  @Input() title: string;
  @Input() message: string;

  constructor(private modalDialog: ModalDialogComponent) {}

  onCancelClick(): void {
    this.modalDialog.closeModal(true);
  }

  onConfirmClick(): void {
    this.confirmClicked.emit();
    this.modalDialog.closeModal(true);
  }
}
